'use client';

import styles from './BlogDestaque.module.css';
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Link from 'next/link';
import Button from "../../components/Button/Button";
import classNames from "classnames";
import { useRouter } from 'next/navigation';
import useGetBlogs from "../../hooks/requestQueries/blog/getBlogs";

interface Post {
  id: number;
  slug: string;
  titulo: string;
  chamada: string;
  imagem: string;
  categoria: string;
}

const BlogDestaque = () => {
  const router = useRouter();

  // Usando o hook useGetBlogs para buscar os blogs
  const { data, isLoading, isError } = useGetBlogs("", 1, 3); // Busca vazia, página 1, quantidade 3

  const posts: Post[] = data?.data.data || [];

  return (
    <section className={styles.blogDestaques} aria-labelledby="blog-title">
      <h2 id="blog-title" className="hidetext">Blog</h2>
      <div className="uiContainer">
        <Breadcrumb titulo="Blog" color="blue200" showBackButton={false} useH2={true} />

        <div className={styles.containerDestaques}>
          {isLoading ? (
            <p>Carregando...</p>
          ) : isError ? (
            <p>Erro ao carregar os blogs.</p>
          ) : posts.length > 0 ? (
            posts.map((post) => (
              <article key={post.id} className={styles.itemDestaque}>
                <Link
                  href={`/Blog/${post.slug}`}
                  className={styles.linkDestaque}
                  // aria-label={`Leia mais sobre: ${post.titulo}`}
                  onClick={() => window.scrollTo({ top: 0 })}
                >
                  <div>
                    <div className={styles.imgDestaque}>
                      <img src={post.imagem || '/images/blogdestaque/imagempadraoblog.jpg'} loading="lazy" alt={post.titulo} width={405} height={239} tabIndex={0} />
                    </div>
                    <div className={styles.contentDestaque}>
                      <h3 className={styles.title} tabIndex={0}>{post.titulo}</h3>
                      <p tabIndex={0}>{post.chamada}</p>
                    </div>
                  </div>
                </Link>
              </article>
            ))
          ) : (
            <p className={styles.noResults}>Nenhuma matéria encontrada.</p>
          )}
        </div>

        <Button
          arialabel="Ver todo o conteúdo do Blog"
          text="Ver todo o conteúdo"
          url="/Blog"
          onClick={() => router.push("/Blog")}
          className={classNames('btnPadrao', 'btnBlue')}
        />
      </div>
    </section>
  );
};

export default BlogDestaque;
